import { connect } from 'react-redux'
import Users from './Users.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsUsers.chartType,
    granularity: state.analyticsUsers.granularity,
    dateRange: state.analyticsUsers.dateRange,
    customDateRange: state.analyticsUsers.customDateRange,
    channelNameToFilter: state.analyticsUsers.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.usersChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.usersChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.usersMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.usersChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.usersChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users)
